/* eslint-disable */
import PropTypes from 'prop-types';
import FormikTextField from './FormikTextField';

const FormikTextFieldWithClearError = ({ clearBackendError, name, ...props }) => {
  const handleChange = (e) => {
    // Clear backend error when user starts typing
    if (clearBackendError && name) {
      clearBackendError(name);
    }
  };

  return (
    <FormikTextField
      name={name}
      {...props}
      onInput={handleChange}
    />
  );
};

FormikTextFieldWithClearError.propTypes = {
  clearBackendError: PropTypes.func,
  name: PropTypes.string.isRequired,
};

export default FormikTextFieldWithClearError;
